import { getTextField, isValidEmail } from '@lender/utils';
import { array, object, string } from 'yup';

const validEmailsTest = array().test(
  'valid-emails',
  'One or more email addresses are invalid',
  values => !values || values.every(({ value }) => isValidEmail(value)),
);

const MAX_ATTACHMENTS_SIZE_MB = 20;
const BYTES_PER_KB = 1024;

export const MAX_RECIPIENTS_LENGTH = 100;
const MIN_RECIPIENTS_LENGTH = 1;

export const MAX_ATTACHMENTS_SIZE = MAX_ATTACHMENTS_SIZE_MB * BYTES_PER_KB * BYTES_PER_KB;

export const MAX_SUBJECT_LENGTH = 998;
export const TRUNCATED_SUBJECT_LENGTH = 80;

const BODY_ERROR_TEXT = 'Body can not be empty';

export const SNIPPETS_BUTTON_STYLES = { textTransform: 'none' };

export const getSchema = isForward =>
  object().shape({
    recipients: array()
      .min(
        MIN_RECIPIENTS_LENGTH,
        `Please select at least ${MIN_RECIPIENTS_LENGTH} contact in "To" field`,
      )
      .max(
        MAX_ATTACHMENTS_SIZE,
        `Field "To" cannot have more than ${MAX_RECIPIENTS_LENGTH} recipients`,
      )
      .concat(validEmailsTest),
    cc: array()
      .max(MAX_ATTACHMENTS_SIZE, `Field cannot have more than ${MAX_RECIPIENTS_LENGTH} recipients`)
      .concat(validEmailsTest),
    bcc: array()
      .max(MAX_ATTACHMENTS_SIZE, `Field cannot have more than ${MAX_RECIPIENTS_LENGTH} recipients`)
      .concat(validEmailsTest),
    subject: getTextField({ isRequired: true, errorText: 'Subject can not be empty' }).max(
      MAX_SUBJECT_LENGTH,
    ),
    body: isForward ? string().notRequired() : string().required(BODY_ERROR_TEXT),
  });
